/*
 * AUTO-GENERATED FILE — DO NOT EDIT.
 * Source of truth: packages/style-rules/src/
 * Regenerate with `pnpm generate:shared` (runs automatically at build/dev/install).
 */

/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import {
  parseDateString,
  parseLocalDateString,
  parseTimeString,
} from './date-utils';
import type { RangeLiteral } from './literal-schemas';
import { type NumericValue, resolveNumericLiteral } from './numeric-utils';

/** Resolves a range literal to the numeric representation used for interpolation. */
export function resolveRangeLiteral(value: RangeLiteral): NumericValue | null {
  if (typeof value === 'object' && value !== null) {
    if ('datetime' in value) {
      return parseDateString(value.datetime);
    }
    if ('localdatetime' in value) {
      return parseLocalDateString(value.localdatetime);
    }
    if ('time' in value) {
      return parseTimeString(value.time);
    }
  }
  return resolveNumericLiteral(value);
}
